const INGREDIENT_KEYS = {
  rice: "ingredientRice", broccoli: "ingredientBroccoli", tofu: "ingredientTofu",
  chicken: "ingredientChicken", pasta: "ingredientPasta", tomato: "ingredientTomato",
  tomatoes: "ingredientTomato", spinach: "ingredientSpinach", salmon: "ingredientSalmon",
  potatoes: "ingredientPotatoes", potato: "ingredientPotatoes",
};

export function localizedIngredientName(name, t) {
  const key = INGREDIENT_KEYS[String(name || "").trim().toLowerCase()];
  return key ? t(key) : name;
}

export function scaledIngredientQuantity(ingredient, factor = 1) {
  const value = Number(ingredient?.quantity || 0) * Number(factor || 1);
  const unit = String(ingredient?.unit || "").toLowerCase();
  let increment = Number(ingredient?.cooking_increment || 0);
  if (!(increment > 0)) {
    increment = ["g", "ml"].includes(unit) ? (value <= 100 ? 5 : value <= 500 ? 10 : 25)
      : ["kg", "l"].includes(unit) ? 0.05 : 0.25;
  }
  const rounded = Math.round(value / increment) * increment;
  return Math.round(rounded * 1000) / 1000;
}

export function cookingIngredients(meal, portionPlan = {}) {
  const projected = portionPlan.household_cooking_ingredients || [];
  if (projected.length) return projected.map((row) => ({
    ...row, quantity: row.cooking_quantity, exact_quantity: row.exact_quantity,
  }));
  const factor = Number(portionPlan.household_cooking_factor || 1);
  return (meal?.ingredients || []).map((row) => ({
    ...row, exact_quantity: Number(row.quantity || 0) * factor,
    quantity: scaledIngredientQuantity(row, factor),
  }));
}

export function nutritionLine(meal) {
  const nutrition = meal?.nutrition || {};
  return {
    kcal: Math.round(Number(nutrition.kcal || 0)),
    protein: Math.round(Number(nutrition.protein || 0)),
    carbohydrates: Math.round(Number(nutrition.carbohydrates || 0)),
    fat: Math.round(Number(nutrition.fat || 0)),
  };
}
